import React from 'react'
import './UserSearch.css';
import Autosuggest from 'react-autosuggest';
import { searchService } from '_services';
import styles from './UserSearch.module.css';

export class UserSearch extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            suggestions: [],
            loading: false
        };
        this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    }

    users = [];

    async getUsers(value) {
        var retval = [];
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;

        if (inputLength >= 3) {
            var tmp = await searchService.userSearch(inputValue);
            retval = tmp.entities.results ? Object.values(tmp.entities.results) : [];
        }
        return retval;
    }

    getSuggestionValue(suggestion) {
        return suggestion.details;
    }

    renderSuggestion(suggestion) {
        return (
            <span>{suggestion.details}</span>
        );
    }


    async loadSuggestions(value) {

        this.setState({
            isLoading: true
        });

        this.users = await this.getUsers(value);
        this.setState({
            isLoading: false,
            suggestions: this.users
        });
    }

    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue
        });
    };

    onBlur = (event, { highlightedSuggestion }) => {
        if (this.users && this.users.filter(user => user.details.toLowerCase() === this.state.value.toLowerCase()).length !== 1) {
            this.setState({
                value: ''
            });
        }
    }

    onSuggestionSelected(event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) {
        if (this.props.onSelected) {
            this.props.onSelected(suggestion.id);
        }
    }

    onSuggestionsFetchRequested = ({ value }) => {
        this.loadSuggestions(value);
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };



    render() {
        const { value, suggestions } = this.state;
        const inputProps = {
            placeholder: "Search",
            value,
            onChange: this.onChange,
            onBlur: this.onBlur,
        };

        return (
            <div className={styles.autosuggest_wrapper}>
                <Autosuggest
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    onSuggestionSelected={this.onSuggestionSelected}
                    getSuggestionValue={this.getSuggestionValue}
                    renderSuggestion={this.renderSuggestion}
                    inputProps={inputProps} />
            </div>
        );
    }
}
